if (!customElements.get('jc-product-grid')) {
  customElements.define(
    'jc-product-grid',
    class JCProductGrid extends HTMLElement {
      constructor() {
        super();
        this.list = this.querySelector('.jc-product-grid__list');
        this.sectionId = this.dataset.sectionId;
        this.observeMore();
      }

      observeMore() {
        if (this.observer) this.observer.disconnect();

        const more = this.querySelector('.jc-product-grid__more');
        const link = more ? more.querySelector('a[href]') : null;
        if (!link) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.observer.disconnect();
                this.loadMore(more, link.href);
              }
            });
          },
          { rootMargin: '0px 0px 400px 0px' }
        );

        this.observer.observe(more);
      }

      loadMore(more, url) {
        more.classList.add('jc-product-grid__more--loading');

        const separator = url.includes('?') ? '&' : '?';
        fetch(`${url}${separator}section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            html.querySelectorAll('.jc-product-grid__list .jc-wrapper').forEach((card) => {
              this.list.appendChild(card);
            });

            const newMore = html.querySelector('.jc-product-grid__more');
            if (newMore) {
              more.replaceWith(newMore);
              this.observeMore();
            } else {
              more.remove();
            }

            history.replaceState({}, '', url);
          })
          .catch(() => {
            more.classList.remove('jc-product-grid__more--loading');
          });
      }
    }
  );
}